export const translations = {
  ro: {
    nav: {
      home: 'Acasă',
      context: 'Context Global',
      construction: 'Construcții 3D',
      industries: 'Industrii Strategice',
      legislation: 'Legislație',
      microfactory: 'Model Microfabrică',
      evolution: 'Evoluție Tehnologică',
      conclusion: 'Concluzie',
      sources: 'Surse',
      logout: 'Deconectare'
    },
    login: {
      title: 'Prezentare Generală',
      subtitle: 'Informațiile prezentate sunt destinate exclusiv scopurilor de analiză strategică.',
      username: 'Utilizator',
      password: 'Parolă',
      submit: 'Autentificare',
      error: 'Credențiale invalide',
      confidential: 'Document Confidențial'
    },
    home: {
      badge: 'Briefing Strategic 2025',
      title: 'Romania Additive Strategy',
      subtitle: 'De ce 3D? Tehnologie strategică pentru viitorul industrial al României',
      intro: 'Imprimarea 3D nu mai este experiment. Este infrastructura industrială.',
      description: 'România se află la o răscruce strategică. Într-o lume marcată de fragmentare a lanțurilor de aprovizionare, criză energetică și competiție tehnologică, fabricația aditivă reprezintă oportunitatea de a construi independență industrială și reziliență economică.',
      cta: 'Citește Briefingul',
      stats: {
        market: 'Piața Globală AM',
        marketValue: '$44.5B',
        growth: 'Creștere CAGR',
        growthValue: '20.8%',
        projection: 'Proiecție 2032',
        projectionValue: '$175B'
      }
    },
    context: {
      badge: 'Analiză Globală',
      title: 'Context Global',
      subtitle: 'Fabricația aditivă redefinește industria la nivel mondial',
      intro: 'De la America la Europa și Asia, liderii industriali investesc masiv în tehnologia de imprimare 3D. Nu este o tendință - este o transformare structurală.',
      section1: {
        title: 'ICON - Construcții Revoluționare',
        text: 'ICON, companie americană pionier în construcții 3D, a demonstrat că este posibilă construirea de locuințe în 24-48 ore folosind betoane speciale și roboți de imprimare la scară mare. Proiectele lor includ comunități întregi de case imprimate, reducând dramatic costurile și timpul de construcție.'
      },
      section2: {
        title: 'COBOD - Liderul European',
        text: 'COBOD, din Danemarca, produce cele mai mari imprimante 3D pentru construcții din lume. Tehnologia lor BOD2 poate imprima structuri de până la 300 mp în mai puțin de o săptămână, cu o reducere de 50% a deșeurilor de construcție.'
      },
      section3: {
        title: 'Perspective World Economic Forum',
        text: 'Forumul Economic Mondial identifică construcțiile 3D ca una dintre cele mai promițătoare soluții pentru criza globală a locuințelor. Tehnologia poate reduce cu 30-40% costurile de construcție și cu 60% emisiile de carbon asociate industriei construcțiilor.'
      },
      section4: {
        title: 'Apărare - US Department of Defense',
        text: 'Departamentul Apărării al SUA investește masiv în fabricația aditivă pentru a asigura pregătirea militară. Tehnologia permite producerea rapidă de piese de schimb direct pe câmpul de luptă, reducând dependența de lanțurile tradiționale de aprovizionare și îmbunătățind semnificativ timpul de răspuns în situații critice.'
      },
      section5: {
        title: 'Medicină - Mayo Clinic',
        text: 'Mayo Clinic utilizează imprimarea 3D pentru a revoluționa chirurgia și tratamentele medicale. De la implanturi personalizate create specific pentru anatomia pacientului, la ghiduri chirurgicale și modele anatomice pentru planificarea operațiilor complexe, tehnologia salvează vieți și reduce timpul de recuperare.'
      },
      section6: {
        title: 'Industrie Auto - BMW Group',
        text: 'BMW operează cel mai avansat campus de fabricație aditivă din industria auto. Cu peste 300.000 de componente imprimate anual, de la prototipuri la piese de serie, compania demonstrează că imprimarea 3D nu mai este doar pentru cercetare - este producție de masă pentru vehicule premium.'
      }
    },
    construction: {
      badge: 'Construcții Inovatoare',
      title: 'Construcții 3D',
      subtitle: 'Revoluția în industria construcțiilor prin fabricație aditivă',
      benefits: {
        title: 'Avantaje Cheie',
        cost: {
          title: 'Reducere Costuri',
          desc: 'Până la 40% economii la costurile de construcție prin automatizare și reducerea deșeurilor materiale.'
        },
        time: {
          title: 'Timp de Execuție',
          desc: 'Case complete în 24-72 ore. Structuri complexe în săptămâni în loc de luni.'
        },
        digital: {
          title: 'Control Digital',
          desc: 'Precizie milimetrică, design parametric și optimizare structurală prin algoritmi AI.'
        },
        sustainable: {
          title: 'Sustenabilitate',
          desc: 'Reducere cu 60% a deșeurilor, posibilitatea folosirii materialelor reciclate și locale.'
        }
      },
      romania: {
        title: 'Potențialul în România',
        text: 'România, cu sectorul său de construcții în creștere și nevoia acută de locuințe accesibile, reprezintă un teren ideal pentru adoptarea construcțiilor 3D. Forța de muncă calificată în IT și inginerie, combinată cu costurile operaționale competitive, poziționează țara ca potențial hub regional pentru această tehnologie.'
      }
    },
    industries: {
      badge: 'Sectoare Strategice',
      title: 'Industrii Strategice',
      subtitle: 'Fabricația aditivă transformă sectoarele industriale cheie',
      auto: {
        title: 'Industria Auto',
        company: 'BMW Additive Manufacturing Campus',
        desc: 'BMW operează unul dintre cele mai avansate centre de fabricație aditivă din lume. Produc anual peste 300.000 de componente imprimate 3D, de la prototipuri la piese de serie pentru vehiculele lor premium.'
      },
      aerospace: {
        title: 'Industria Aerospațială',
        company: 'Airbus Additive Manufacturing',
        desc: 'Airbus utilizează fabricația aditivă pentru componente critice ale aeronavelor, reducând greutatea cu până la 55% și costurile cu 90% pentru anumite piese. Peste 1.000 de piese imprimate 3D zboară pe avioanele A350.'
      },
      medical: {
        title: 'Medicină și Sănătate',
        company: 'Mayo Clinic 3D Printing',
        desc: 'Mayo Clinic folosește imprimarea 3D pentru implanturi personalizate, ghiduri chirurgicale și modele anatomice pentru planificarea operațiilor complexe. Tehnologia a revoluționat chirurgia reconstructivă și ortopedică.'
      },
      defense: {
        title: 'Industria de Apărare',
        company: 'US Department of Defense',
        desc: 'Departamentul Apărării SUA investește masiv în fabricația aditivă pentru mentenanța și reparația rapidă a echipamentelor militare, reducând dependența de lanțurile tradiționale de aprovizionare.'
      }
    },
    legislation: {
      badge: 'Cadru Legal',
      title: 'Legislație și Reglementare',
      subtitle: 'Standardele și reglementările care guvernează fabricația aditivă',
      national: {
        title: 'Legislație Națională România',
        law1: {
          title: 'Legea 50/1991',
          desc: 'Privind autorizarea executării lucrărilor de construcții - necesită actualizare pentru a include metodele de construcție aditivă.'
        },
        law2: {
          title: 'Legea 10/1995',
          desc: 'Privind calitatea în construcții - cadrul pentru asigurarea calității trebuie extins pentru materialele și procesele de fabricație aditivă.'
        }
      },
      strategy: {
        title: 'Unde se află România acum?',
        subtitle: 'Strategie Națională și Documente Oficiale',
        intro: 'România a adoptat o strategie națională care include priorități pentru cercetare avansată și transfer tehnologic, inclusiv tehnologii digitale emergente precum fabricația aditivă.',
        docs: {
          sncisi: {
            title: 'Strategia Națională de Cercetare, Inovare și Specializare Inteligentă 2022–2027',
            desc: 'Document aprobat prin Hotărârea Guvernului nr. 933/20 iulie 2022, publicat în Monitorul Oficial. Include priorități privind cercetarea avansată, inovarea și transferul tehnologic.',
            link: 'https://www.research.gov.ro/programe-nationale/strategia-nationala-de-cercetare-inovare-si-specializare-inteligenta-2022-2027/#flipbook-df_27867/1/',
            linkText: 'Descarcă Strategia (PDF)'
          },
          presentation: {
            title: 'Prezentare oficială SNCISI',
            desc: 'Pagina oficială de prezentare a strategiilor de cercetare-inovare ale statului. Include detalii despre viziunea și obiectivele strategiei naționale de CDI.',
            link: 'https://www.research.gov.ro/wp-content/uploads/2025/07/sncisi_19-iulie.pdf',
            linkText: 'Vezi prezentarea pe research.gov.ro'
          },
          uefiscdi: {
            title: 'Rapoarte de consultare - Specializare Inteligentă',
            desc: 'Rapoarte preliminare privind prioritățile tehnologice (inclusiv fabricație aditivă) din procesul de specializare inteligentă.',
            link: 'https://uefiscdi.gov.ro/',
            linkText: 'Vezi rapoarte UEFISCDI'
          }
        },
        initiatives: {
          title: 'Inițiative și Proiecte Relevante',
          esa: {
            title: 'Cooperare cu Agenția Spațială Europeană (ESA)',
            desc: 'ESA a sprijinit implementarea unui proiect de 3D printing industrial la COMOTI - proces industrial de fabricație aditivă pentru industria aerospațială.',
            link: 'https://www.esa.int/Enabling_Support/Space_Engineering_Technology/New_3D_printing_scheme_in_Romania',
            linkText: 'Detalii proiect ESA în România'
          },
          siramm: {
            title: 'Proiectul SIRAMM - Cercetare Universitară',
            desc: 'Proiect în colaborare UE atașat universităților tehnice, exemplu de dezvoltare a tehnologiilor additive manufacturing în România.',
            link: 'https://siramm.eu/',
            linkText: 'Detalii proiect SIRAMM'
          }
        }
      },
      international: {
        title: 'Standarde Internaționale',
        iso: {
          title: 'ISO/ASTM 52900:2021',
          desc: 'Standardul fundamental pentru terminologia și principiile generale în fabricația aditivă, adoptat la nivel global.'
        },
        edf: {
          title: 'European Defence Fund',
          desc: 'Fondul European pentru Apărare finanțează proiecte de fabricație aditivă pentru industria de apărare europeană.'
        }
      },
      control: {
        title: 'Control și Export',
        itar: {
          title: 'ITAR (SUA)',
          desc: 'International Traffic in Arms Regulations - controlează exportul tehnologiilor de fabricație aditivă cu aplicații militare.'
        },
        dual: {
          title: 'Regimul Dual-Use UE',
          desc: 'Reglementarea exporturilor de bunuri cu dublă utilizare, incluzând echipamente și software pentru fabricația aditivă avansată.'
        }
      },
      note: {
        title: 'Notă Strategică',
        text: 'Controlul statului în industriile sensibile (apărare, aerospațial, medical) este esențial. România trebuie să dezvolte un cadru legislativ care să permită inovația, menținând în același timp securitatea națională și suveranitatea tehnologică.'
      }
    },
    microfactory: {
      badge: 'Model Strategic',
      title: 'Model Microfabrică România',
      subtitle: 'Rețea distribuită de producție pentru independență industrială',
      intro: 'Conceptul de microfabrică reprezintă o paradigmă nouă în producția industrială: unități mici, flexibile și interconectate, capabile să producă local și la cerere.',
      features: {
        network: {
          title: 'Rețea Distribuită',
          desc: 'Microfabrici în fiecare regiune a țării, conectate digital, capabile să colaboreze pentru proiecte mari.'
        },
        production: {
          title: 'Producție Locală',
          desc: 'Reducerea dependenței de importuri, timpi de livrare minimi, personalizare pentru piața locală.'
        },
        control: {
          title: 'Control Strategic',
          desc: 'Suveranitate asupra capacităților de producție critice, independență în situații de criză.'
        },
        logistics: {
          title: 'Independență Logistică',
          desc: 'Eliminarea vulnerabilităților lanțurilor de aprovizionare globale, producție just-in-time.'
        },
        ai: {
          title: 'Integrare AI',
          desc: 'Optimizare automată a producției, mentenanță predictivă, design generativ.'
        },
        scale: {
          title: 'Scalabilitate',
          desc: 'Capacitatea de a scala rapid producția în funcție de cerere, fără investiții masive.'
        }
      },
      diagram: {
        title: 'Arhitectura Rețelei',
        hub: 'Hub Central',
        nodes: 'Noduri Regionale',
        flow: 'Flux Digital'
      }
    },
    evolution: {
      badge: 'Perspectivă Tehnologică',
      title: 'Evoluție Tehnologică',
      subtitle: 'Cum convergența tehnologică accelerează fabricația aditivă',
      internet: {
        title: 'Internet & Colaborare',
        subtitle: 'Conectivitate Globală',
        text: 'Internetul a revoluționat colaborarea în design industrial. Platforme CAD cloud permit echipelor distribuite global să lucreze simultan pe modele complexe, accelerând dramatic ciclul de dezvoltare a produselor.'
      },
      green: {
        title: 'Energie Verde',
        subtitle: 'Sustenabilitate Industrială',
        text: 'Tranziția către energie regenerabilă transformă economia fabricației. Conform IEA, energia solară și eoliană devin cele mai ieftine surse de electricitate, reducând costurile operaționale ale microfabricilor.',
        source: 'Sursa: IEA Renewables 2023'
      },
      ai: {
        title: 'Inteligență Artificială',
        subtitle: 'Design Generativ',
        text: 'AI-ul și designul generativ revoluționează modul în care proiectăm produse. Autodesk Generative Design poate genera mii de variante optimizate în ore, reducând greutatea și materialul necesar cu până la 70%.'
      }
    },
    conclusion: {
      badge: 'Oportunitate Strategică',
      title: 'CONCLUZIE',
      subtitle: 'România: Hub Regional pentru Fabricația Aditivă',
      points: {
        resilience: {
          title: 'Reziliență',
          text: 'Capacitatea de a produce local reduce vulnerabilitatea la perturbările lanțurilor globale de aprovizionare.'
        },
        growth: {
          title: 'Creștere CAGR',
          text: 'Piața globală de fabricație aditivă crește cu 20.8% anual, proiectată să atingă $175B până în 2032.'
        },
        opportunity: {
          title: 'Oportunitate Regională',
          text: 'România poate deveni hub regional pentru Europa Centrală și de Est, cu acces la piețe de peste 150 milioane de consumatori.'
        },
        control: {
          title: 'Control Strategic',
          text: 'Suveranitate tehnologică și independență industrială într-un context geopolitic complex.'
        }
      },
      final: {
        title: 'Momentul Este Acum',
        text: 'Investiția în fabricația aditivă în România nu este doar o oportunitate de business - este o decizie strategică pentru viitorul industrial al țării. Tehnologia este matură, piața este în creștere, iar România are toate resursele necesare pentru a deveni un lider regional.'
      }
    },
    sources: {
      badge: 'Referințe',
      title: 'Surse și Documentație',
      subtitle: 'Toate informațiile prezentate provin din surse oficiale verificabile',
      categories: {
        construction: 'Construcții 3D',
        industry: 'Industrie & Producție',
        legislation: 'Legislație & Standarde',
        research: 'Cercetare & Tehnologie'
      }
    },
    footer: {
      confidential: 'Confidential User Briefing',
      contact: 'Contact',
      copyright: '© 2025 Romania Additive Strategy — @3DCollective. Document strategic.',
      disclaimer: 'Informațiile prezentate sunt destinate exclusiv scopurilor de analiză strategică.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      context: 'Global Context',
      construction: '3D Construction',
      industries: 'Strategic Industries',
      legislation: 'Legislation',
      microfactory: 'Microfactory Model',
      evolution: 'Tech Evolution',
      conclusion: 'Conclusion',
      sources: 'Sources',
      logout: 'Logout'
    },
    login: {
      title: 'General Overview',
      subtitle: 'Information presented is intended exclusively for strategic analysis purposes.',
      username: 'Username',
      password: 'Password',
      submit: 'Authenticate',
      error: 'Invalid credentials',
      confidential: 'Confidential Document'
    },
    home: {
      badge: 'Strategic Briefing 2025',
      title: 'Romania Additive Strategy',
      subtitle: 'Why 3D? Strategic Technology for Romania\'s Industrial Future',
      intro: '3D printing is no longer an experiment. It is industrial infrastructure.',
      description: 'Romania stands at a strategic crossroads. In a world marked by supply chain fragmentation, energy crisis, and technological competition, additive manufacturing represents the opportunity to build industrial independence and economic resilience.',
      cta: 'Read Briefing',
      stats: {
        market: 'Global AM Market',
        marketValue: '$44.5B',
        growth: 'CAGR Growth',
        growthValue: '20.8%',
        projection: '2032 Projection',
        projectionValue: '$175B'
      }
    },
    context: {
      badge: 'Global Analysis',
      title: 'Global Context',
      subtitle: 'Additive manufacturing is redefining industry worldwide',
      intro: 'From America to Europe and Asia, industrial leaders are investing heavily in 3D printing technology. This is not a trend - it is a structural transformation.',
      section1: {
        title: 'ICON - Revolutionary Construction',
        text: 'ICON, an American pioneer in 3D construction, has demonstrated that it is possible to build homes in 24-48 hours using special concrete and large-scale printing robots. Their projects include entire communities of printed houses, dramatically reducing costs and construction time.'
      },
      section2: {
        title: 'COBOD - The European Leader',
        text: 'COBOD, from Denmark, produces the world\'s largest 3D printers for construction. Their BOD2 technology can print structures up to 300 sqm in less than a week, with a 50% reduction in construction waste.'
      },
      section3: {
        title: 'World Economic Forum Insights',
        text: 'The World Economic Forum identifies 3D construction as one of the most promising solutions for the global housing crisis. The technology can reduce construction costs by 30-40% and carbon emissions associated with the construction industry by 60%.'
      },
      section4: {
        title: 'Defense - US Department of Defense',
        text: 'The US Department of Defense is investing heavily in additive manufacturing to ensure military readiness. The technology enables rapid production of spare parts directly on the battlefield, reducing dependence on traditional supply chains and significantly improving response time in critical situations.'
      },
      section5: {
        title: 'Medicine - Mayo Clinic',
        text: 'Mayo Clinic uses 3D printing to revolutionize surgery and medical treatments. From personalized implants created specifically for patient anatomy, to surgical guides and anatomical models for planning complex operations, the technology saves lives and reduces recovery time.'
      },
      section6: {
        title: 'Automotive Industry - BMW Group',
        text: 'BMW operates the most advanced additive manufacturing campus in the automotive industry. With over 300,000 components printed annually, from prototypes to series parts, the company demonstrates that 3D printing is no longer just for research - it\'s mass production for premium vehicles.'
      }
    },
    construction: {
      badge: 'Innovative Construction',
      title: '3D Construction',
      subtitle: 'Revolution in the construction industry through additive manufacturing',
      benefits: {
        title: 'Key Advantages',
        cost: {
          title: 'Cost Reduction',
          desc: 'Up to 40% savings on construction costs through automation and material waste reduction.'
        },
        time: {
          title: 'Execution Time',
          desc: 'Complete houses in 24-72 hours. Complex structures in weeks instead of months.'
        },
        digital: {
          title: 'Digital Control',
          desc: 'Millimeter precision, parametric design, and structural optimization through AI algorithms.'
        },
        sustainable: {
          title: 'Sustainability',
          desc: '60% waste reduction, possibility of using recycled and local materials.'
        }
      },
      romania: {
        title: 'Potential in Romania',
        text: 'Romania, with its growing construction sector and acute need for affordable housing, represents ideal ground for adopting 3D construction. The skilled IT and engineering workforce, combined with competitive operational costs, positions the country as a potential regional hub for this technology.'
      }
    },
    industries: {
      badge: 'Strategic Sectors',
      title: 'Strategic Industries',
      subtitle: 'Additive manufacturing transforms key industrial sectors',
      auto: {
        title: 'Automotive Industry',
        company: 'BMW Additive Manufacturing Campus',
        desc: 'BMW operates one of the most advanced additive manufacturing centers in the world. They annually produce over 300,000 3D printed components, from prototypes to series parts for their premium vehicles.'
      },
      aerospace: {
        title: 'Aerospace Industry',
        company: 'Airbus Additive Manufacturing',
        desc: 'Airbus uses additive manufacturing for critical aircraft components, reducing weight by up to 55% and costs by 90% for certain parts. Over 1,000 3D printed parts fly on A350 aircraft.'
      },
      medical: {
        title: 'Medicine & Healthcare',
        company: 'Mayo Clinic 3D Printing',
        desc: 'Mayo Clinic uses 3D printing for personalized implants, surgical guides, and anatomical models for planning complex operations. The technology has revolutionized reconstructive and orthopedic surgery.'
      },
      defense: {
        title: 'Defense Industry',
        company: 'US Department of Defense',
        desc: 'The US Department of Defense is investing heavily in additive manufacturing for rapid maintenance and repair of military equipment, reducing dependence on traditional supply chains.'
      }
    },
    legislation: {
      badge: 'Legal Framework',
      title: 'Legislation & Regulation',
      subtitle: 'Standards and regulations governing additive manufacturing',
      national: {
        title: 'Romanian National Legislation',
        law1: {
          title: 'Law 50/1991',
          desc: 'Regarding authorization of construction works - requires update to include additive construction methods.'
        },
        law2: {
          title: 'Law 10/1995',
          desc: 'Regarding quality in construction - quality assurance framework needs to be extended for additive manufacturing materials and processes.'
        }
      },
      strategy: {
        title: 'Where is Romania now?',
        subtitle: 'National Strategy and Official Documents',
        intro: 'Romania has adopted a national strategy that includes priorities for advanced research and technology transfer, including emerging digital technologies such as additive manufacturing.',
        docs: {
          sncisi: {
            title: 'National Strategy for Research, Innovation and Smart Specialization 2022–2027',
            desc: 'Document approved by Government Decision no. 933/July 20, 2022, published in the Official Gazette. Includes priorities for advanced research, innovation and technology transfer.',
            link: 'https://www.research.gov.ro/programe-nationale/strategia-nationala-de-cercetare-inovare-si-specializare-inteligenta-2022-2027/#flipbook-df_27867/1/',
            linkText: 'Download Strategy (PDF)'
          },
          presentation: {
            title: 'Official SNCISI Presentation',
            desc: 'Official page presenting the state research-innovation strategies. Includes details about the vision and objectives of the national RDI strategy.',
            link: 'https://www.research.gov.ro/wp-content/uploads/2025/07/sncisi_19-iulie.pdf',
            linkText: 'See presentation on research.gov.ro'
          },
          uefiscdi: {
            title: 'Consultation Reports - Smart Specialization',
            desc: 'Preliminary reports on technological priorities (including additive manufacturing) from the smart specialization process.',
            link: 'https://uefiscdi.gov.ro/',
            linkText: 'See UEFISCDI reports'
          }
        },
        initiatives: {
          title: 'Relevant Initiatives and Projects',
          esa: {
            title: 'Cooperation with European Space Agency (ESA)',
            desc: 'ESA supported the implementation of an industrial 3D printing project at COMOTI - industrial additive manufacturing process for the aerospace industry.',
            link: 'https://www.esa.int/Enabling_Support/Space_Engineering_Technology/New_3D_printing_scheme_in_Romania',
            linkText: 'ESA project details in Romania'
          },
          siramm: {
            title: 'SIRAMM Project - University Research',
            desc: 'EU collaboration project attached to technical universities, an example of additive manufacturing technology development in Romania.',
            link: 'https://siramm.eu/',
            linkText: 'SIRAMM project details'
          }
        }
      },
      international: {
        title: 'International Standards',
        iso: {
          title: 'ISO/ASTM 52900:2021',
          desc: 'The fundamental standard for terminology and general principles in additive manufacturing, adopted globally.'
        },
        edf: {
          title: 'European Defence Fund',
          desc: 'The European Defence Fund finances additive manufacturing projects for the European defense industry.'
        }
      },
      control: {
        title: 'Control & Export',
        itar: {
          title: 'ITAR (USA)',
          desc: 'International Traffic in Arms Regulations - controls export of additive manufacturing technologies with military applications.'
        },
        dual: {
          title: 'EU Dual-Use Regime',
          desc: 'Regulation of dual-use goods exports, including equipment and software for advanced additive manufacturing.'
        }
      },
      note: {
        title: 'Strategic Note',
        text: 'State control in sensitive industries (defense, aerospace, medical) is essential. Romania must develop a legislative framework that allows innovation while maintaining national security and technological sovereignty.'
      }
    },
    microfactory: {
      badge: 'Strategic Model',
      title: 'Microfactory Model Romania',
      subtitle: 'Distributed production network for industrial independence',
      intro: 'The microfactory concept represents a new paradigm in industrial production: small, flexible, and interconnected units, capable of producing locally and on demand.',
      features: {
        network: {
          title: 'Distributed Network',
          desc: 'Microfactories in every region of the country, digitally connected, capable of collaborating on large projects.'
        },
        production: {
          title: 'Local Production',
          desc: 'Reducing import dependency, minimal delivery times, customization for the local market.'
        },
        control: {
          title: 'Strategic Control',
          desc: 'Sovereignty over critical production capabilities, independence in crisis situations.'
        },
        logistics: {
          title: 'Logistics Independence',
          desc: 'Eliminating vulnerabilities of global supply chains, just-in-time production.'
        },
        ai: {
          title: 'AI Integration',
          desc: 'Automatic production optimization, predictive maintenance, generative design.'
        },
        scale: {
          title: 'Scalability',
          desc: 'Ability to rapidly scale production based on demand, without massive investments.'
        }
      },
      diagram: {
        title: 'Network Architecture',
        hub: 'Central Hub',
        nodes: 'Regional Nodes',
        flow: 'Digital Flow'
      }
    },
    evolution: {
      badge: 'Technology Perspective',
      title: 'Technological Evolution',
      subtitle: 'How technological convergence accelerates additive manufacturing',
      internet: {
        title: 'Internet & Collaboration',
        subtitle: 'Global Connectivity',
        text: 'The internet has revolutionized collaboration in industrial design. Cloud CAD platforms allow globally distributed teams to work simultaneously on complex models, dramatically accelerating the product development cycle.'
      },
      green: {
        title: 'Green Energy',
        subtitle: 'Industrial Sustainability',
        text: 'The transition to renewable energy is transforming manufacturing economics. According to IEA, solar and wind are becoming the cheapest sources of electricity, reducing the operational costs of microfactories.',
        source: 'Source: IEA Renewables 2023'
      },
      ai: {
        title: 'Artificial Intelligence',
        subtitle: 'Generative Design',
        text: 'AI and generative design are revolutionizing how we design products. Autodesk Generative Design can generate thousands of optimized variants in hours, reducing weight and material needed by up to 70%.'
      }
    },
    conclusion: {
      badge: 'Strategic Opportunity',
      title: 'CONCLUSION',
      subtitle: 'Romania: Regional Hub for Additive Manufacturing',
      points: {
        resilience: {
          title: 'Resilience',
          text: 'Local production capability reduces vulnerability to disruptions in global supply chains.'
        },
        growth: {
          title: 'CAGR Growth',
          text: 'The global additive manufacturing market is growing at 20.8% annually, projected to reach $175B by 2032.'
        },
        opportunity: {
          title: 'Regional Opportunity',
          text: 'Romania can become a regional hub for Central and Eastern Europe, with access to markets of over 150 million consumers.'
        },
        control: {
          title: 'Strategic Control',
          text: 'Technological sovereignty and industrial independence in a complex geopolitical context.'
        }
      },
      final: {
        title: 'The Time Is Now',
        text: 'Investing in additive manufacturing in Romania is not just a business opportunity - it is a strategic decision for the country\'s industrial future. The technology is mature, the market is growing, and Romania has all the necessary resources to become a regional leader.'
      }
    },
    sources: {
      badge: 'References',
      title: 'Sources & Documentation',
      subtitle: 'All information presented comes from verifiable official sources',
      categories: {
        construction: '3D Construction',
        industry: 'Industry & Manufacturing',
        legislation: 'Legislation & Standards',
        research: 'Research & Technology'
      }
    },
    footer: {
      confidential: 'Confidential User Briefing',
      contact: 'Contact',
      copyright: '© 2025 Romania Additive Strategy — @3DCollective. Strategic document.',
      disclaimer: 'Information presented is intended exclusively for strategic analysis purposes.'
    }
  }
};

export const sourcesList = [
  {
    category: 'construction',
    sources: [
      { name: 'ICON Build', url: 'https://www.iconbuild.com', desc: { ro: 'Lider în construcții 3D din SUA', en: 'US leader in 3D construction' } },
      { name: 'COBOD', url: 'https://cobod.com/projects/', desc: { ro: 'Producător european de imprimante 3D pentru construcții', en: 'European manufacturer of 3D construction printers' } },
      { name: 'World Economic Forum', url: 'https://www.weforum.org/agenda/2023/03/3d-printed-homes-construction/', desc: { ro: 'Analiza locuințelor imprimate 3D', en: '3D printed homes analysis' } }
    ]
  },
  {
    category: 'industry',
    sources: [
      { name: 'BMW Additive Manufacturing', url: 'https://www.bmwgroup.com/en/innovation/additive-manufacturing.html', desc: { ro: 'Centrul BMW de fabricație aditivă', en: 'BMW additive manufacturing campus' } },
      { name: 'Airbus Additive Manufacturing', url: 'https://www.airbus.com/en/innovation/digital-design-manufacturing-and-services/additive-manufacturing', desc: { ro: 'Fabricația aditivă Airbus', en: 'Airbus additive manufacturing' } },
      { name: 'Mayo Clinic 3D Printing', url: 'https://www.mayoclinic.org/medical-professionals/orthopedic-surgery/news/3d-printing-in-medicine/mac-20430503', desc: { ro: 'Imprimare 3D în medicină', en: '3D printing in medicine' } },
      { name: 'US Department of Defense', url: 'https://www.defense.gov/News/Feature-Stories/Story/Article/3142267/additive-manufacturing-supports-military-readiness/', desc: { ro: 'Fabricația aditivă pentru apărare', en: 'Additive manufacturing for defense' } }
    ]
  },
  {
    category: 'legislation',
    sources: [
      { name: 'ISO/ASTM 52900:2021', url: 'https://www.iso.org/standard/74514.html', desc: { ro: 'Standard internațional pentru fabricație aditivă', en: 'International standard for additive manufacturing' } },
      { name: 'European Defence Fund', url: 'https://defence-industry-space.ec.europa.eu/eu-defence-industry/european-defence-fund-edf_en', desc: { ro: 'Fondul European pentru Apărare', en: 'European Defence Fund' } },
      { name: 'ITAR Regulations', url: 'https://www.pmddtc.state.gov/ddtc_public?id=ddtc_public_portal_itar_landing', desc: { ro: 'Reglementări ITAR pentru export', en: 'ITAR export regulations' } },
      { name: 'EU Dual-Use Export', url: 'https://policy.trade.ec.europa.eu/help-exporters-and-importers/exporting-dual-use-items_en', desc: { ro: 'Export bunuri cu dublă utilizare UE', en: 'EU dual-use goods export' } }
    ]
  },
  {
    category: 'research',
    sources: [
      { name: 'IEA Renewables 2023', url: 'https://www.iea.org/reports/renewables-2023', desc: { ro: 'Raport energie regenerabilă', en: 'Renewable energy report' } },
      { name: 'Autodesk Generative Design', url: 'https://www.autodesk.com/solutions/generative-design', desc: { ro: 'Design generativ Autodesk', en: 'Autodesk generative design' } }
    ]
  }
];
